import { RESET_REDUX_STATE, RESET_SAVE_TEMPORARY_DATA, SAVE_TEMPORARY_DATA } from "../constants";

const initState = {
  saveData: {},
  path: "",
  tempPageName: ""
};

const tempWindowsData = (state = initState, action) => {
  const { type, payload } = action;
  switch (type) {
    case SAVE_TEMPORARY_DATA: {
      return {
        ...payload,
      };
    }
    case RESET_SAVE_TEMPORARY_DATA: {
      return initState;
    }

    case RESET_REDUX_STATE: {
      return initState
    }

    default:
      return state;
  }
};

export default tempWindowsData;
